<template>
      <div class="classroomEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'classroom', params: {} }">
          Classroom
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'classroomEdit', params:{id: id} }">
            Edit Classroom
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Classroom</v-card-title>
          <v-card-text>
            <classroom-form :id="id"></classroom-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import ClassroomForm from './ClassroomForm.vue';

    export default {
      name: 'classroom',
      data () {
        return {
          id: null
        }
      },
      components: {
        ClassroomForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    